import React, { useState } from 'react';
import './OEMAndChannels.css';
import { sendQuoteRequestEmail } from '../utils/emailService';
import { sanitizeFormData, validateFormData } from '../utils/inputSanitizer';

const OEMAndChannels = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    partdesc: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    // Clear error when user starts typing
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Send email using EmailJS
      const sanitized = sanitizeFormData(formData);
      const validation = validateFormData(
        { ...sanitized, email: sanitized.email || '' },
        ['name', 'email', 'partdesc']
      );

      if (!validation.isValid) {
        setError(validation.errors.join('. '));
        return;
      }

      await sendQuoteRequestEmail(sanitized);
      
      setSubmitted(true);
      setFormData({
        name: '',
        phone: '',
        email: '',
        company: '',
        partdesc: ''
      });
      
      setTimeout(() => {
        setSubmitted(false);
      }, 5000);
    } catch (err) {
      console.error('Failed to send email:', err);
      setError('Failed to send your request. Please try again or contact us directly at info@bigstridesinc.com');
    } finally {
      setLoading(false);
    }
  };

  const partners = [
    { name: 'Frick', image: '13.Frick_.jpg', url: 'https://www.johnsoncontrols.com/industrial-refrigeration/industrial-refrigeration' },
    { name: 'RoFlo', image: '24.RoFlo_.jpg', url: 'https://www.roflocompressors.com/' },
    { name: 'Ariel', image: '12.Ariel_.jpg', url: 'https://www.arielcorp.com/' },
    { name: 'Howden', image: '18.Howden.jpg', url: 'https://www.howden.com/en-us/home' },
    { name: 'Superior', image: '10.Superior.jpg', url: '#' },
    { name: 'Ajax', image: '11.Ajax_.jpg', url: '#' },
    { name: 'Sullair', image: '14.Sullair.jpg', url: '#' },
    { name: 'GE', image: '15.GE_.jpg', url: '#' },
    { name: 'Gardner Denver', image: '16.GardnerDenver.jpg', url: '#' },
    { name: 'Gemini', image: '17.Gemini.jpg', url: '#' },
    { name: 'Kobelco', image: '19.Kobelco.jpg', url: '#' },
    { name: 'Mayacom', image: '20.Mayacom.jpg', url: '#' },
    { name: 'Quincy', image: '21.Quincy.jpg', url: '#' },
    { name: 'Tamrotor', image: '22.Tamrotor.jpg', url: '#' },
    { name: 'Dresser Rand', image: '23.DresserRand.jpg', url: '#' },
    { name: 'Worthington', image: '25.Worthington.jpg', url: '#' },
    { name: 'Knox', image: '26.Knox_.jpg', url: '#' },
    { name: 'IR', image: '27.IR_.jpg', url: '#' },
    { name: 'TDI', image: '28.TDI_.jpg', url: '#' },
    { name: 'PRQ', image: '29.PRQ_.jpg', url: '#' },
    { name: 'Waukesha', image: '3.-Waukesha.jpg', url: '#' },
    { name: 'Goulds', image: '30.Goulds.jpg', url: '#' },
    { name: 'Corken', image: '31.Corken.jpg', url: '#' },
    { name: 'Deming', image: '32.Deming.jpg', url: '#' },
    { name: 'Dean', image: '33.Dean_.jpg', url: '#' },
    { name: 'Grundfos', image: '34.Grundfos.jpg', url: '#' },
    { name: 'Swagelok', image: '35.Swagelok.jpg', url: '#' },
    { name: 'Texsteam', image: '36.Texsteam.jpg', url: '#' },
    { name: 'Endyn', image: '37.Endyn_.jpg', url: '#' },
    { name: 'Impco', image: '38.Impco_.jpg', url: '#' },
    { name: 'Murphy', image: '39.Murphy.jpg', url: '#' },
    { name: 'Cummins', image: '4.Cummins.jpg', url: '#' },
    { name: 'Garrett', image: '40.Garrett.jpg', url: '#' },
    { name: 'Fisher', image: '41.Fisher.jpg', url: '#' },
    { name: 'GM', image: '42.GM_.jpg', url: '#' },
    { name: 'Cooper Energy', image: '5.CooperEnergy.jpg', url: '#' },
    { name: 'Caterpillar', image: '6.Caterpillar.jpg', url: '#' },
    { name: 'Clark', image: '7.Clark_.jpg', url: '#' },
    { name: 'Arrow', image: '8.Arrow_.jpg', url: '#' },
    { name: 'Baker Hughes', image: '9.BakerHughes.jpg', url: '#' },
  ];

  return (
    <div className="oem-page">
      <section className="oem-hero section">
        <div className="container">
          <h1 className="page-title">Parts Line Card</h1>
          <p className="page-subtitle">
            Request information about OEM and aftermarket parts from our extensive network of partners
          </p>
        </div>
      </section>

      <section className="oem-content section">
        <div className="container">
          <div className="oem-grid">
            <div className="quote-form-container">
              <div className="card">
                <h2 className="card-title">Request More Information</h2>
                {submitted ? (
                  <div className="success-message">
                    <p>✓ Thank you! Your request has been submitted successfully. We'll get back to you soon.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="quote-form">
                    {error && (
                      <div className="error-message">
                        {error}
                      </div>
                    )}
                    <div className="form-group">
                      <label htmlFor="name" className="form-label">Name *</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone" className="form-label">Phone</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="Your Phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="email" className="form-label">Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="company" className="form-label">Company</label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        className="form-control"
                        placeholder="Your Company"
                        value={formData.company}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="partdesc" className="form-label">Part number & description *</label>
                      <textarea
                        id="partdesc"
                        name="partdesc"
                        className="form-control"
                        rows="4"
                        placeholder="Part number & description"
                        value={formData.partdesc}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                      {loading ? 'Sending...' : 'Submit Request'}
                    </button>
                  </form>
                )}
              </div>
            </div>

            <div className="partners-container">
              <div className="card">
                <h2 className="card-title">Our Partners</h2>
                <div className="partners-grid">
                  {partners.map((partner, index) => (
                    <a
                      key={index}
                      href={partner.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="partner-item"
                    >
                      <img
                        src={`/img/parts/${partner.image}`}
                        alt={partner.name}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OEMAndChannels;

